// Pure rules of the shared sidebar (D-161): clamping, snapping to collapsed, what is remembered.
export interface SidebarState { width: number; collapsed: boolean }
export interface SidebarLimits { defaultWidth: number; min: number; max: number }

export const clampWidth = (w: number, { min, max }: SidebarLimits) => Math.round(Math.min(max, Math.max(min, Number.isFinite(w) ? w : min)));

/** Dragging under half the minimum collapses, as Mail's and Slack's panes do. */
export const shouldCollapse = (w: number, { min }: SidebarLimits) => w < min / 2;

/** The width a drag or key press asks for, and whether it collapses. */
export function resolveWidth(w: number, l: SidebarLimits): SidebarState {
  return shouldCollapse(w, l) ? { width: clampWidth(l.defaultWidth, l), collapsed: true } : { width: clampWidth(w, l), collapsed: false };
}

export const storageKey = (app: string, id: string) => `dz-sidebar:${app}:${id}`;

export function parseStored(raw: string | null, l: SidebarLimits): SidebarState {
  try {
    const v = JSON.parse(raw ?? '');
    return { width: clampWidth(typeof v.width === 'number' ? v.width : l.defaultWidth, l), collapsed: v.collapsed === true };
  } catch { return { width: l.defaultWidth, collapsed: false }; }
}

/** At this width and below the app's own drawer takes over (the apps' phone breakpoint, 760 px). */
export const NARROW_QUERY = '(max-width: 760px)';
